import React, {useContext, useMemo} from 'react'
import {
  Dropdown,
  DropdownRelayoutTriggerContext,
  TippyInstance
} from '@components/common/dropdown/dropdown'
import {TippyProps} from '@tippyjs/react'

export type RenderProps = {
  toggleVisible: () => void
}

export interface SharedDropdownProps
  extends Pick<
    TippyProps,
    | 'animation'
    | 'className'
    | 'reference'
    | 'trigger'
    | 'hideOnClick'
    | 'offset'
    | 'maxWidth'
  > {
  onVisibleChange?: (visible: boolean) => void // todo: consider name "onClose"
  visible?: boolean // todo: consider name "isOpen"
  contentState?: unknown
  hideArrow?: boolean
  duration?: number
  placement?: TippyProps['placement']
  fallbackPlacements?: TippyProps['placement'][]
  theme?: 'light-border' | 'new-tooltips' | 'new-menu'
  hideOverlay?: boolean
  instanceRef?: React.MutableRefObject<TippyInstance | undefined>
  onCreate?: (tippy: TippyInstance) => void
  /**
   * At this moment arrow works unstable, thus it's better to keep it disabled
   */
  withArrow?: boolean
  content?: React.ReactNode | (() => React.ReactNode)
  children: React.ReactNode
  /**
   * Если true, то дропдаун будет автоматически пересчитывать позицию при изменении размера контента
   * @default false
   */
  autoRelayout?: boolean
}

/**
 * Controlled dropdown component.
 * @param props
 * @constructor
 */
export const SharedDropdown = (props: SharedDropdownProps) => {
  const {withArrow, content, visible, children, autoRelayout, ...rest} = props

  const dynamicContent = useMemo(() => {
    if (typeof content === 'function') {
      return visible || typeof visible === 'undefined' ? content() : null
    }
    return content
  }, [content, visible])

  return (
    <Dropdown
      {...rest}
      visible={visible}
      content={dynamicContent}
      hideArrow={!withArrow}
      autoRelayout={autoRelayout}
    >
      {children}
    </Dropdown>
  )
}

// Экспортируем функцию пересчета позиции
export const useDropdownRelayout = () =>
  useContext(DropdownRelayoutTriggerContext)
